
export class KendoColumnDefinition{
    public values?: any[];
    constructor(
         public field: string,
         public title: string,
         public template:string,
         public format: string ='',
         public filterable: boolean = true,
         public columnMenu:boolean = false,
         public aggregates:Array<string> = [],
         public footerTemplate: string = "",
         public groupFooterTemplate: string = "",
         public hidden:boolean = false,
         public groupHeaderTemplate: string = "",
         public attributes:Object = {},
         public groupable:boolean = true,
         public width:number = 180,
         public headerAttributes: Object = {}){}
}



// WEBPACK FOOTER //
// ./app/insa-models/kendoColumnDefWrapper.ts